import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AmenitiesRoutingModule } from './amenities-routing.module';
import { AmenitiesListComponent } from './amenities-list/amenities-list.component';
import { AmenitiesCreateComponent } from './amenities-create/amenities-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [AmenitiesListComponent, AmenitiesCreateComponent],
  imports: [
    CommonModule,
    AmenitiesRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class AmenitiesModule { }
